import { render, staticRenderFns } from "./IntraoralArchControls.vue?vue&type=template&id=3063feec&scoped=true&"
import script from "./IntraoralArchControls.vue?vue&type=script&lang=js&"
export * from "./IntraoralArchControls.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralArchControls.vue?vue&type=style&index=0&id=3063feec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063feec",
  null
  
)

export default component.exports